import createCache from '@emotion/cache';
/*
 * MUI is using Emotion as its default styled engine.
 * We need to extract the styles from the Emotion instance.
 * For this, we need to share the same cache configuration for both the client and server
 */
export function createEmotionCache() {
  return createCache({ key: 'css' });
}
